import { useEffect, useState } from 'react'

const useWindowHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasMounted(true)
    }
  }, [])
  return hasMounted
}

export default useWindowHasMounted
